import { cn } from "@/lib/utils";
import { Menu } from "components/core/Menu";
import { Switch } from "components/core/Switch";
import { Text } from "components/core/Text";
import { IconButton } from "components/core/buttons/IconButton";

import { Config } from "./ChromeHomeBoard";

export function ChromeHomeBoardConfigMenu({
    config,
    onChangeConfig,
    onSubmitTopSitesPermission
}: {
    config: Config;
    onChangeConfig: (config: Config) => void;
    onSubmitTopSitesPermission: (granted: boolean) => void;
}) {
    return (
        <Menu
            className="hidden lg:block"
            anchorEl={
                <IconButton
                    className="p-1.5 [&_svg]:text-grey-500"
                    name="Setting"
                    size="medium"
                    variant="filled"
                    color="grey"
                />
            }
            placement="left-start"
            offset={4}
        >
            <div className="auto-rows-6 grid grid-cols-[110px_1fr] gap-y-3 p-4 px-5 [&_label]:flex [&_label]:items-center">
                <Text variant="body3" tag="label">
                    구글 검색창
                </Text>
                <Switch
                    checked={config.use_chrome_search}
                    onChange={() => {
                        onChangeConfig({
                            ...config,
                            use_chrome_search: !config.use_chrome_search
                        });
                    }}
                />
                <Text variant="body3" tag="label">
                    바로가기 아이콘
                </Text>
                <Switch
                    checked={
                        config.has_topSites_permission &&
                        config.use_chrome_shortcut
                    }
                    onChange={async () => {
                        if (config.has_topSites_permission) {
                            onChangeConfig({
                                ...config,
                                use_chrome_shortcut: !config.use_chrome_shortcut
                            });
                        } else {
                            const granted = await chrome.permissions.request({
                                permissions: ["topSites"]
                            });

                            onSubmitTopSitesPermission(granted);
                        }
                    }}
                />
            </div>
        </Menu>
    );
}
